const STEPS = [
    {
        n: "01",
        title: "Diagnóstico",
        desc: "Visita técnica, levantamiento y análisis de riesgos. Entendemos tu operación antes de cotizar.",
    },
    {
        n: "02",
        title: "Diseño",
        desc: "Planos, ingeniería de detalle y selección de equipos. Sin sobre-especificar, sin recortar lo crítico.",
    },
    {
        n: "03",
        title: "Implementación",
        desc: "Instalación certificada, cuadrillas propias y plan de obra con hitos verificables semana a semana.",
    },
    {
        n: "04",
        title: "Puesta en marcha",
        desc: "Pruebas funcionales, integración a tus sistemas y capacitación al equipo operador.",
    },
    {
        n: "05",
        title: "Monitoreo & Soporte",
        desc: "Mantenimiento, métricas y respuesta SLA. Operamos contigo, no solo te entregamos.",
    },
];

const Process = () => {
    return (
        <section
            id="proceso"
            data-testid="process-section"
            className="border-b border-white/10"
        >
            <div className="px-6 md:px-12 lg:px-16 py-20 md:py-28 grid grid-cols-12 gap-10">
                <div className="col-span-12 lg:col-span-4">
                    <div className="lg:sticky lg:top-28">
                        <p className="text-xs md:text-sm font-mono tracking-[0.3em] uppercase text-white/50 mb-4">
                            / 003 — Proceso
                        </p>
                        <h2 className="font-display uppercase leading-[0.9] tracking-tighter text-5xl md:text-6xl">
                            Del plano
                            <br />
                            al sitio.
                        </h2>
                        <p className="mt-6 font-mono text-sm md:text-base text-white/60 leading-relaxed max-w-sm">
                            Una metodología auditable en 5 fases. Cada hito se
                            entrega documentado y aprobado por el cliente.
                        </p>
                    </div>
                </div>

                <div className="col-span-12 lg:col-span-8">
                    <ol>
                        {STEPS.map((s, i) => (
                            <li
                                key={s.n}
                                data-testid={`process-step-${s.n}`}
                                className={`grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 ${
                                    i !== STEPS.length - 1
                                        ? "border-b border-white/10"
                                        : ""
                                }`}
                            >
                                <span className="col-span-3 md:col-span-2 font-display text-4xl md:text-6xl text-white/15">
                                    {s.n}
                                </span>
                                <div className="col-span-9 md:col-span-10">
                                    <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 font-mono text-sm md:text-base text-white/65 leading-relaxed max-w-2xl">
                                        {s.desc}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
};

export default Process;
